import React, { useEffect, useState } from 'react';
import { onSnapshot, collection, query, where } from '@firebase/firestore';
import { db } from '../service/Firebase-config';
import { List, ListItemButton, ListItemIcon, ListItemText, Avatar, Tooltip, Box } from '@mui/material';
import { useAuth } from '../service/AuthContext';
import { stringAvatar, chunkArray } from '../common/util';
import { useGlobalContext } from '../context/GlobalContext';

export default function ListStudentPerTeacher({ searchQuery, statusFilter }) {
  const [people, setPeople] = useState([]);
  const [filteredPeople, setFilteredPeople] = useState([]);
  const { currentUser, userInfo } = useAuth();
  const { selectedUser, setSelectedUser, setTotalStars } = useGlobalContext();
  
  useEffect(() => {
    if (currentUser && userInfo?.studentList?.length > 0) {
      const collectionRef = collection(db, "students");
  
      // studentList를 30개씩 나누기
      const chunks = chunkArray(userInfo.studentList, 30);
      let allStudents = new Map(); // 중복 방지를 위한 Map
      let unsubscribes = [];
  
      chunks.forEach((chunk) => {
        const whereQuery = query(collectionRef, where("uid", "in", chunk));
  
        const unsubscribe = onSnapshot(whereQuery, (snapshot) => {
          const studentList = snapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));
  
          // 중복 방지: id 기준으로 최신 데이터 유지
          studentList.forEach((student) => allStudents.set(student.id, student));
  
          const sortedStudents = Array.from(allStudents.values()).sort((a, b) =>
            a.displayName.localeCompare(b.displayName)
          );
  
          setPeople(sortedStudents);
          setFilteredPeople(sortedStudents);
        });
  
        unsubscribes.push(unsubscribe);
      });
  
      // Cleanup: 구독 해제
      return () => unsubscribes.forEach((unsubscribe) => unsubscribe());
    } else {
      setPeople([]);
      setFilteredPeople([]);
    }
  }, [currentUser, userInfo]);

  useEffect(() => {
    let tempData = people;

    // Apply search filter
    if (searchQuery) {
      tempData = tempData.filter(row => row.displayName.toLowerCase().includes(searchQuery.toLowerCase()));
    }

    // Apply status filter
    if (statusFilter !== 'all') {
      const isActive = statusFilter === 'active';
      tempData = tempData.filter(row => row.active === isActive);
    }

    setFilteredPeople(tempData);
  }, [searchQuery, statusFilter, people]);

  const handleClick = (user) => {
    setSelectedUser(user);
    setTotalStars(user.totalStars);
  };

  return (
    <Box 
      sx={{
        height: '78vh', // 전체 화면 높이
        overflowY: 'auto', // 세로 스크롤 활성화
        overflowX: 'hidden', // 가로 스크롤 비활성화
        borderTop: '1px solid #ddd', // 선택적으로 테두리 추가
        borderRadius: '4px', // 선택적으로 모서리 둥글게
      }}
    >
      <List>
        {filteredPeople && filteredPeople.map(user => (
          <ListItemButton
            key={user?.id}
            onClick={() => handleClick(user)}
            selected={selectedUser?.id === user?.id}
          >
            <ListItemIcon>
              <Tooltip title={user.displayName} arrow>
                {user.photoUrl ? (
                  <Avatar src={user.photoUrl} />
                ) : (
                  <Avatar {...stringAvatar(user.displayName)} />
                )}
              </Tooltip>
            </ListItemIcon>
            <ListItemText primary={user.displayName} />
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
}
